import React from 'react';
import './ApplicantView.css';

function ApplicantView({ applicant, onClose }) {
  // Use your resume link for now
  const resumeUrl = 'https://resumekraft.com/wp-content/uploads/2023/11/2.jpg';

  return (
    <div className="Applicant-view">
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal" onClick={e => e.stopPropagation()}>
          <button className="close-cross" onClick={onClose} aria-label="Close">&times;</button>

          <div className="modal-content">
            <div className="resume-preview">
              <iframe
                src={resumeUrl}
                title="Resume Preview"
                frameBorder="0"
                width="100%"
                height="100%"
              />
            </div>

            <div className="details">
              <h3>Applicant Details</h3>
              <p><strong>Name:</strong> {applicant.name}</p>
              <p><strong>Email:</strong> {applicant.email}</p>
              <p><strong>Job Title:</strong> {applicant.jobTitle}</p>
              <p><strong>Date Applied:</strong> {applicant.dateApplied}</p>
              <button
                className="view-resume-btn"
                onClick={() => window.open(applicant.resume, '_blank', 'noopener,noreferrer')}
              >
                View Resume
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicantView;
